var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    stroke: "#112348"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5301 27.4658C46.289 26.7067 45.8877 26.0163 45.3164 25.4435C42.9306 23.0459 38.5228 23.5893 35.471 26.6563C32.9765 29.1632 32.1613 32.5803 33.2497 35.0549C42.3899 34.3645 45.648 29.2892 46.5287 27.4672L46.5301 27.4658Z",
    fill: "#D69B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1268 25.2322C15.1268 25.2322 15.4863 30.6562 13.927 32.8256C12.3676 34.9949 9.7296 36.9835 8.40992 35.4164C7.09023 33.8493 9.18891 31.5175 11.3489 30.6044C11.3489 30.6044 10.1491 25.2308 10.1491 23.6034C10.1491 21.9761 9.37007 17.9399 12.4888 18.0002C15.6076 18.0604 29.0999 24.8709 29.5193 27.7628C29.9388 30.6562 27.2409 33.2471 22.9822 31.138C18.7249 29.0289 15.1268 25.2322 15.1268 25.2322Z",
    fill: "#D69B29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9178 27.6366C49.8175 27.4154 49.6377 27.2459 49.412 27.1605C49.1848 27.0751 48.9396 27.0835 48.7194 27.1843C48.4992 27.2851 48.3306 27.4658 48.247 27.6913C48.2372 27.7151 47.2896 30.1561 44.9192 32.4207C42.7035 34.5382 38.7416 36.947 32.4484 36.3924C29.4885 36.1319 27.0651 35.814 25.1155 35.5591C18.2955 34.6684 15.744 34.3337 9.61377 38.3236C9.19432 38.5967 9.07447 39.1611 9.34621 39.5827C9.51344 39.8432 9.79772 39.9986 10.1071 39.9986C10.2813 39.9986 10.4513 39.9482 10.599 39.853C16.1704 36.2271 18.3666 36.5142 24.8828 37.3657C26.8449 37.622 29.2864 37.9413 32.2895 38.206C32.971 38.2662 33.6273 38.2942 34.26 38.2942C40.1003 38.2942 43.9228 35.884 46.1664 33.7399C48.8601 31.1658 49.8983 28.4461 49.9401 28.3327C50.0251 28.1044 50.0168 27.8579 49.9164 27.6366H49.9178Z",
    fill: "#D69B29"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 22,
    fill: "white",
    transform: "translate(8 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b1fc56ad32f935b28123109ac324e9d6.svg";
export { ForwardRef as ReactComponent };